const btn = document.querySelector(".collection-description-btn");
const wrapper = document.querySelector(".collection-description-wrapper");

if (btn && wrapper) {
  btn.addEventListener("click", () => {
    wrapper.classList.toggle("active");

    // Toggle button text
    if (wrapper.classList.contains("active")) {
      btn.textContent = "Read less";
    } else {
      btn.textContent = "Read more";
    }
  });
}